export default '/build/b3622942.svg'